export const editorErrorMessages = {
  title: {
    required: "Required",
  },
  blogContent: {
    required: "Required",
  },
};

export const BLOG_STATUS = {
  PUBLISHED: "published",
  DRAFT: "draft",
};
